/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Updated_LabelInputs */

const en_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

const fr_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis a jour`)
};

const de_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiert`)
};

const it_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornato`)
};

const ru_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлено`)
};

const es_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado`)
};

const zh_cn2_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const ja_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const hi_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अद्यतन`)
};

const pt_pt2_manual_qc_updated_label = /** @type {(inputs: Manual_Qc_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizado`)
};

/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Manual_Qc_Updated_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_updated_label = /** @type {((inputs?: Manual_Qc_Updated_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Updated_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_updated_label(inputs)
	if (locale === "de") return de_manual_qc_updated_label(inputs)
	if (locale === "it") return it_manual_qc_updated_label(inputs)
	if (locale === "ru") return ru_manual_qc_updated_label(inputs)
	if (locale === "es") return es_manual_qc_updated_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_updated_label(inputs)
	if (locale === "ja") return ja_manual_qc_updated_label(inputs)
	if (locale === "hi") return hi_manual_qc_updated_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_updated_label(inputs)
	return en_manual_qc_updated_label(inputs)
});